import { render } from "./ChangeKubernetesClusterAffinity.vue?vue&type=template&id=6f96c739&scoped=true"
import script from "./ChangeKubernetesClusterAffinity.vue?vue&type=script&lang=js"
export * from "./ChangeKubernetesClusterAffinity.vue?vue&type=script&lang=js"

import "./ChangeKubernetesClusterAffinity.vue?vue&type=style&index=0&id=6f96c739&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f96c739"]])

export default __exports__